import styled from 'styled-components';
import { fonts, colors } from 'assets/styled/tokens';

export const BreadcrumbsContainer = styled.nav`
  font-size: 14px;
  font-family: ${fonts.family.text};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;

  a {
    color: ${colors.gray};
    text-decoration: none;
    //margin-right: 10px;
    font-weight: 400;

    &:hover {
      cursor: pointer;
    }
  }

  .crumb {
    //margin: 0 0 0 10px;
    color: ${colors.gray};
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }

  .last {
    font-weight: 700;
    color: ${colors.carbon};
  }

  svg {
    margin: 0 4px;
  }
`;
